export interface CmpsPeriodCompareData {
    option: string;
    disabled: boolean;
}

export enum CmpsPeriodCompareType {
    DAYS,
    WEEKS,
    MONTHS,
}
